import {request} from '@weplanet-web/core'

const PATH = '/majorCustomer'

function getMajorCustomer(data: IGetMajorCustomer) {
  return request({url: PATH, method: 'GET', params: data})
}

export {getMajorCustomer}
